import React from 'react';

export default class CommunityIcon extends React.Component {
    render() {
        var style = {
            backgroundColor: 'transparent',
            backgroundImage: 'url("' + this.props.icon_url + '")'
        };

        return <div>
                <div className="icon" style={style}></div>
                <div className="name">{this.props.name}</div>
            </div>;
    }
};
